import axios from "axios";
import { API_SERVICE_BACKEND } from "src/config";
import { storageConfigsName } from "src/storageConfig";

export async function uploadToBlobStorage(file, blobName, containerName) {
  try {
    const config = storageConfigsName[containerName];

    if (!config) {
      throw new Error(`Invalid Container Name: ${containerName}`);
    }

    const formData = new FormData();
    formData.append("file", file); // same File object from your input
    formData.append("blobName", blobName);
    formData.append("containerName", config.containerName);

    const response = await axios.post(
      `${API_SERVICE_BACKEND}/generate-upload-url`,
      formData,
    );

    // Step 1: Get upload URL from backend
    // const response = await axios.get(
    //   `${API_SERVICE_BACKEND}/generate-upload-url`,
    //   {
    //    params: { blobName, containerName: config.containerName ,file},
    //   });

    const { uploadUrl, fileUrl } = response.data;

    // Step 2: Upload file using PUT to Azure Blob Storage
    // Use fetch instead of axios to avoid Authorization header conflicts with SAS tokens
    // const uploadResponse = await fetch1(uploadUrl, {
    //   method: "PUT",
    //   body: file,
    //   headers: {
    //     "x-ms-blob-type": "BlockBlob",
    //     "Content-Type": file.type || "application/octet-stream",
    //   },
    // });

    // if (!uploadResponse.ok) {
    //   const errorText = await uploadResponse.text();
    //   throw new Error(`Upload failed: ${uploadResponse.status} ${uploadResponse.statusText} - ${errorText}`);
    // }

    return fileUrl;
  } catch (error) {
    console.error("Upload error:", error);
    throw new Error("Upload to blob storage failed");
  }
}
